'use client'

import { Burger, Drawer, ScrollArea, Stack, Text } from '@mantine/core'
import Link from 'next/link'
import { useQueryState } from 'nuqs'
import { parseAsBoolean } from 'nuqs'
import { menuSections } from '../_helpers/menuSections'

export function BurgerMenu() {
	const [menu, setMenu] = useQueryState('menu', parseAsBoolean.withDefault(false))

	return (
		<>
			<Burger opened={menu} onClick={() => setMenu(!menu)} />
			<Drawer opened={menu} onClose={() => setMenu(false)} size={200} withCloseButton={false}>
				<ScrollArea>
					<Stack gap="md">
						<ScrollArea mt="xl">
							<Link href="/">
								<Text size="xl" fz="lg">
									Início
								</Text>
							</Link>
							{Object.values(menuSections).map(({ id, name }) => (
								<Link key={id} href={`?section=${id}`}>
									<Text size="xl" fz="lg">
										{name}
									</Text>
								</Link>
							))}
							<Link href="/faq">
								<Text size="xl" fz="lg">
									Perguntas Frequentes
								</Text>
							</Link>
						</ScrollArea>
					</Stack>
				</ScrollArea>
			</Drawer>
		</>
	)
}
